export default __webpack_public_path__ + "static/media/acms-evaluation.a5f95dbd.svg";